import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ExtendedAttribute } from './extended-attribute';

export class ExtendedAttributeStateModel extends EntityStateModel<ExtendedAttribute> {}
